import { RequiredField } from '../types/utility';

export function isObject(obj: unknown): obj is object {
  return Boolean(obj) && typeof obj === 'object';
}

export function propertyIsDefined<O extends object, K extends keyof O>(
  obj: O,
  key: K
): obj is RequiredField<O, K> {
  return Boolean(key in obj && obj[key]);
}

export function propertyExists<K extends string>(
  obj: object,
  key: K
): obj is { [key in K]: unknown } {
  return key in obj;
}

export function isWindow(win: unknown): win is Window {
  return isObject(win) && propertyExists(win, 'top') && propertyExists(win, 'self');
}

export function isPopupWindow(win: unknown): win is Window {
  return isWindow(win) && Boolean(win.top) && win.top === win.self;
}

export function isIframe(win: unknown): win is HTMLIFrameElement {
  try {
    return (
      isObject(win) &&
      propertyExists(win, 'nodeName') &&
      typeof win.nodeName === 'string' &&
      win.nodeName.toLowerCase() === 'iframe'
    );
  } catch (e) {
    return false;
  }
}
